export default {
  scenes: {
    silence: {
      beats: {
        chapterStart: {
          events: [
            {
              type: 'showLocation',
              locationId: 'weddingVenue'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'The day of the wedding has arrived...',
              choices: [
                {
                  text: 'Continue',
                  next: {
                    scene: 'silence',
                    beat: 'watchingDreamsEnd'
                  }
                },
                {
                  text: 'Skip to a different ending',
                  next: {
                    scene: 'endings',
                    beat: 'endingChoice'
                  }
                }
              ]
            }
          ]
        },
        watchingDreamsEnd: {
          events: [
            {
              type: 'showLocation',
              locationId: 'weddingVenue'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'minister',
              variation: 'neutral',
              text: 'If anyone knows why these two should not be wed, speak now or forever hold your peace...'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'thinking',
              text: '(internal thought, hand clenching at her side) Some things are meant to remain unspoken.'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'I... do.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'How does Isabelle handle the moment?',
              choices: [
                {
                  text: 'Bear Witness',
                  next: {
                    scene: 'silence',
                    beat: 'theReception'
                  }
                },
                {
                  text: 'Leave Mid-Ceremony',
                  next: {
                    scene: 'escape',
                    beat: 'walkingAway'
                  }
                }
              ]
            }
          ]
        },
        theReception: {
          events: [
            {
              type: 'showLocation',
              locationId: 'weddingVenue'
            },
            {
              type: 'showCharacter',
              characterId: 'emily',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'emily',
              variation: 'happy',
              text: 'You have to dance with us, Isabelle!'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'How does she say goodbye?',
              choices: [
                {
                  text: 'One Last Dance',
                  next: {
                    scene: 'endings',
                    beat: 'movingForward'
                  }
                },
                {
                  text: 'Professional Farewell',
                  next: {
                    scene: 'endings',
                    beat: 'freshStart'
                  }
                }
              ]
            }
          ]
        }
      }
    },
    escape: {
      beats: {
        walkingAway: {
          events: [
            {
              type: 'showLocation',
              locationId: 'weddingVenue'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'sad',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'sad',
              text: 'What does she leave behind?',
              choices: [
                {
                  text: 'A Final Note',
                  next: {
                    scene: 'endings',
                    beat: 'newCity'
                  }
                },
                {
                  text: 'Clean Break',
                  next: {
                    scene: 'endings',
                    beat: 'startingOver'
                  }
                }
              ]
            }
          ]
        }
      }
    },
    interruption: {
      beats: {
        momentOfTruth: {
          events: [
            {
              type: 'showLocation',
              locationId: 'weddingVenue'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'What does she say?',
              choices: [
                {
                  text: 'Speak from the Heart',
                  next: {
                    scene: 'endings',
                    beat: 'theChoice'
                  }
                },
                {
                  text: 'Apologize and Run',
                  next: {
                    scene: 'endings',
                    beat: 'theAftermath'
                  }
                }
              ]
            }
          ]
        }
      }
    },
    endings: {
      beats: {
        endingChoice: {
          events: [
            {
              type: 'showLocation',
              locationId: 'weddingVenue'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Which ending would you like to see?',
              choices: [
                {
                  text: 'Moving Forward',
                  next: {
                    scene: 'endings',
                    beat: 'movingForward'
                  }
                },
                {
                  text: 'Fresh Start',
                  next: {
                    scene: 'endings',
                    beat: 'freshStart'
                  }
                },
                {
                  text: 'New City',
                  next: {
                    scene: 'endings',
                    beat: 'newCity'
                  }
                },
                {
                  text: 'Starting Over',
                  next: {
                    scene: 'endings',
                    beat: 'startingOver'
                  }
                },
                {
                  text: 'The Choice',
                  next: {
                    scene: 'endings',
                    beat: 'theChoice'
                  }
                },
                {
                  text: 'The Aftermath',
                  next: {
                    scene: 'endings',
                    beat: 'theAftermath'
                  }
                }
              ]
            }
          ]
        },
        movingForward: {
          events: [
            {
              type: 'showLocation',
              locationId: 'weddingVenue'
            },
            {
              type: 'showCharacter',
              characterId: 'client',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'client',
              variation: 'neutral',
              text: 'Ms. Carter, they say you\'re the best in the business.'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Every love story deserves its perfect ending.'
            },
            {
              type: 'showNarration',
              text: 'Six months later, at another wedding venue.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Every ending is just another beginning.',
              choices: [
                {
                  text: 'The End',
                  goToGameOver: true
                },
                {
                  text: 'Replay Chapter',
                  next: {
                    scene: 'silence',
                    beat: 'chapterStart'
                  }
                }
              ]
            }
          ]
        },
        freshStart: {
          events: [
            {
              type: 'showLocation',
              locationId: 'weddingVenue'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Sometimes the best love story is the one you write for yourself.'
            },
            {
              type: 'showNarration',
              text: 'One year later, in a new city.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Every ending is just another beginning.',
              choices: [
                {
                  text: 'The End',
                  goToGameOver: true
                },
                {
                  text: 'Replay Chapter',
                  next: {
                    scene: 'silence',
                    beat: 'chapterStart'
                  }
                }
              ]
            }
          ]
        },
        newCity: {
          events: [
            {
              type: 'showLocation',
              locationId: 'newApartment'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Time to write my own story.'
            },
            {
              type: 'showNarration',
              text: 'Three months later, somewhere far away.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Every ending is just another beginning.',
              choices: [
                {
                  text: 'The End',
                  goToGameOver: true
                },
                {
                  text: 'Replay Chapter',
                  next: {
                    scene: 'silence',
                    beat: 'chapterStart'
                  }
                }
              ]
            }
          ]
        },
        startingOver: {
          events: [
            {
              type: 'showLocation',
              locationId: 'familyGarden'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Sometimes you have to go back to move forward.'
            },
            {
              type: 'showNarration',
              text: 'Two months later, in her childhood hometown.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Every ending is just another beginning.',
              choices: [
                {
                  text: 'The End',
                  goToGameOver: true
                },
                {
                  text: 'Replay Chapter',
                  next: {
                    scene: 'silence',
                    beat: 'chapterStart'
                  }
                }
              ]
            }
          ]
        },
        theChoice: {
          events: [
            {
              type: 'showLocation',
              locationId: 'weddingVenue'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'emily',
              variation: 'sad',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'I can\'t lie anymore either.'
            },
            {
              type: 'showDialog',
              speaker: 'emily',
              variation: 'crying',
              text: 'How long?'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'sad',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'sad',
              text: 'Emily, I never meant-'
            },
            {
              type: 'showDialog',
              speaker: 'emily',
              variation: 'sad',
              text: 'Just... be happy. Both of you.'
            },
            {
              type: 'showNarration',
              text: 'Three months later.'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Do you regret it?'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'happy',
              text: 'Only that we waited so long.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'THE END',
              choices: [
                {
                  text: 'The End',
                  goToGameOver: true
                },
                {
                  text: 'Replay Chapter',
                  next: {
                    scene: 'silence',
                    beat: 'chapterStart'
                  }
                }
              ]
            }
          ]
        },
        theAftermath: {
          events: [
            {
              type: 'showLocation',
              locationId: 'isabellesOffice'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Some stories end the way they\'re supposed to. Just not the way you expected.'
            },
            {
              type: 'showNarration',
              text: 'Two years later.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Every ending is just another beginning.',
              choices: [
                {
                  text: 'The End',
                  goToGameOver: true
                },
                {
                  text: 'Replay Chapter',
                  next: {
                    scene: 'silence',
                    beat: 'chapterStart'
                  }
                }
              ]
            }
          ]
        }
      }
    }
  }
}
